var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstallAiAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "82px",
    viewBox: "0 0 216 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Domains",
    transform: "translate(-17.000000, -54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(17.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5006525,16 C72.7842628,22.4482767 70,30.3989886 70,39 C70,60.5391052 87.4608948,78 109,78 C130.539105,78 148,60.5391052 148,39 C148,17.4608948 130.539105,0 109,0 C96.1962161,0 84.8335219,6.17003811 77.7230106,15.699021 C73.9225113,14.7494922 71.1377246,11.6621017 71.1377246,8 C71.1377246,3.581722 75.1912902,0 80.1916168,0 L206.946108,0 C211.946434,0 216,3.581722 216,8 C216,12.418278 211.946434,16 206.946108,16 L155.209581,16 C160.209907,16 164.263473,19.581722 164.263473,24 C164.263473,28.418278 160.209907,32 155.209581,32 L183.664671,32 C188.664997,32 192.718563,35.581722 192.718563,40 C192.718563,44.418278 188.664997,48 183.664671,48 L170.505598,48 C164.200838,48 159.08982,51.581722 159.08982,56 C159.08982,58.9455187 161.676647,61.6121853 166.850299,64 C171.850626,64 175.904192,67.581722 175.904192,72 C175.904192,76.418278 171.850626,80 166.850299,80 L59.497006,80 C54.4966794,80 50.4431138,76.418278 50.4431138,72 C50.4431138,67.581722 54.4966794,64 59.497006,64 L9.05389222,64 C4.05356562,64 0,60.418278 0,56 C0,51.581722 4.05356562,48 9.05389222,48 L60.7904192,48 C65.7907458,48 69.8443114,44.418278 69.8443114,40 C69.8443114,35.581722 65.7907458,32 60.7904192,32 L28.4550898,32 C23.4547632,32 19.4011976,28.418278 19.4011976,24 C19.4011976,19.581722 23.4547632,16 28.4550898,16 L77.5006525,16 Z M206.946108,48 C201.945781,48 197.892216,44.418278 197.892216,40 C197.892216,35.581722 201.945781,32 206.946108,32 C211.946434,32 216,35.581722 216,40 C216,44.418278 211.946434,48 206.946108,48 Z",
    id: "Combined-Shape",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(70.000000, 0.000000)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 39,
    cy: 39,
    r: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(83.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6844047,9.17437176 C10.714599,9.08762348 6.61545203,13.0461237 6.52870375,18.0159294 L6.17437176,38.3155953 C6.08762348,43.285401 10.0461237,47.384548 15.0159294,47.4712963 L35.3155953,47.8256282 C40.285401,47.9123765 44.384548,43.9538763 44.4712963,38.9840706 L44.8256282,18.6844047 C44.9123765,13.714599 40.9538763,9.61545203 35.9840706,9.52870375 L15.6844047,9.17437176 Z",
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2,
    transform: "translate(25.500000, 28.500000) rotate(-1.000000) translate(-25.500000, -28.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,3.5 L25,7.5",
    id: "Line",
    stroke: "#6C6969",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    x: 24.25,
    y: 1.25,
    width: 1.5,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,19.25 L45.25,32.75 L47.5,32.75 C48.7426407,32.75 49.75,31.7426407 49.75,30.5 L49.75,22 C49.75,20.4812169 48.5187831,19.25 47,19.25 L45.25,19.25 Z",
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25,19.25 L1.25,32.75 L3.5,32.75 C4.74264069,32.75 5.75,31.7426407 5.75,30.5 L5.75,22 C5.75,20.4812169 4.51878306,19.25 3,19.25 L1.25,19.25 Z",
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    transform: "translate(3.500000, 26.000000) scale(-1, 1) translate(-3.500000, -26.000000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.7226562,34.3789062 L25.0390625,32.5820312 L19.21875,32.5820312 L18.5351562,34.4179688 C18.2682278,35.1341182 18.0403655,35.6175118 17.8515625,35.8681641 C17.6627595,36.1188164 17.3535178,36.2441406 16.9238281,36.2441406 C16.559243,36.2441406 16.2369806,36.1106784 15.9570312,35.84375 C15.6770819,35.5768216 15.5371094,35.2740902 15.5371094,34.9355469 C15.5371094,34.7402334 15.5696611,34.5384125 15.6347656,34.3300781 C15.6998701,34.1217438 15.8072909,33.8320331 15.9570312,33.4609375 L19.6191406,24.1640625 C19.7233078,23.8971341 19.8486321,23.5764993 19.9951172,23.2021484 C20.1416023,22.8277976 20.2978507,22.5169283 20.4638672,22.2695312 C20.6298836,22.0221342 20.8479804,21.8219409 21.1181641,21.6689453 C21.3883477,21.5159498 21.7220032,21.4394531 22.1191406,21.4394531 C22.5227885,21.4394531 22.8596992,21.5159498 23.1298828,21.6689453 C23.4000665,21.8219409 23.6181632,22.018879 23.7841797,22.2597656 C23.9501961,22.5006522 24.0901687,22.7594387 24.2041016,23.0361328 C24.3180344,23.3128269 24.4628897,23.6822894 24.6386719,24.1445312 L28.3789062,33.3828125 C28.6718765,34.085941 28.8183594,34.5970036 28.8183594,34.9160156 C28.8183594,35.2480485 28.6800144,35.5524075 28.4033203,35.8291016 C28.1266262,36.1057957 27.7929707,36.2441406 27.4023438,36.2441406 C27.174478,36.2441406 26.9791675,36.2034509 26.8164062,36.1220703 C26.653645,36.0406897 26.5169276,35.9300137 26.40625,35.7900391 C26.2955724,35.6500644 26.1767584,35.4352228 26.0498047,35.1455078 C25.9228509,34.8557928 25.8138025,34.6002615 25.7226562,34.3789062 Z M19.9804688,30.4042969 L24.2578125,30.4042969 L22.0996094,24.4960938 L19.9804688,30.4042969 Z M31.0644531,34.4765625 L31.0644531,23.1972656 C31.0644531,22.6113252 31.1979153,22.1718765 31.4648438,21.8789062 C31.7317722,21.585936 32.0768208,21.4394531 32.5,21.4394531 C32.9362001,21.4394531 33.2893867,21.5843084 33.5595703,21.8740234 C33.829754,22.1637384 33.9648438,22.6048147 33.9648438,23.1972656 L33.9648438,34.4765625 C33.9648438,35.0690134 33.829754,35.5117173 33.5595703,35.8046875 C33.2893867,36.0976577 32.9362001,36.2441406 32.5,36.2441406 C32.0833313,36.2441406 31.7399102,36.0960301 31.4697266,35.7998047 C31.1995429,35.5035792 31.0644531,35.0625029 31.0644531,34.4765625 Z",
    id: "AI",
    fill: "#6A6666",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallAiAgent);
export default __webpack_public_path__ + "static/media/install-ai-agent.52b4669bdf7603b8a64611b41d924e5b.svg";
export { ForwardRef as ReactComponent };